﻿module.exports = function ($, glossaryUpgrade) {
    return {
        init: function () {
            // If page has the calendar
            if ($('.eventHero__contentBox .wordOfTheDay').length > 0)
                this.initWordOfTheDay();
        },
        initWordOfTheDay: function () {
            $('.wordOfTheDay').click(function () {
                window.location = "/glossary-upgrade/?wordOfTheDayId=" + $(this).parent().data('term-id') + "&alpha=" + $(this).parent().data('term-alpha');
            });
        }
    }
}